import React, { useEffect, useState } from 'react'

// next components

// web3
import { PublicKey } from '@solana/web3.js'
import { useMetaplex } from 'hooks/useMetaplex'
import { LazyBidWithAsset } from 'utils/auction.util'
import { getNFTOwner } from 'utils/nfts.utils'

// components
import OutlineButton from 'components/Button/OutlineButton'

// third party components

// styles
import styles from './index.module.scss'
import { getPriceValue } from 'utils/strings'

// resources
import DefaultNftBG from 'assets/images/default-nft-bg.png'
import ImageWithFoster from 'components/ImageWithFoster'
import { getLocalDate } from 'utils/helpers'
import { useRouter } from 'next/router'
export interface OfferAccordionProps {
  data: LazyBidWithAsset[]
  onAccept: (listing: LazyBidWithAsset) => any
  onCancel: (listing: LazyBidWithAsset) => any
  offerType: 'made' | 'received'
}

type OfferAccordionItemProps = Omit<OfferAccordionProps, 'data'> & {
  listing: OfferAccordionProps['data'][number]
  index: number
}

const OfferAccordionItem = ({ listing, onAccept, onCancel, offerType, index }: OfferAccordionItemProps) => {
  const { metaplex } = useMetaplex()
  const router = useRouter()
  const [ownerOrBuyerAddress, setOwnerOrBuyerAddress] = useState<PublicKey | null>(null)
  useEffect(() => {
    if (offerType === 'made') getNFTOwner(metaplex, listing.asset.mintAddress).then(setOwnerOrBuyerAddress)
    else setOwnerOrBuyerAddress(listing.buyerAddress)
  }, [offerType, metaplex, listing])

  const [assetImageUrl, setAssetImageUrl] = useState<string>('')
  useEffect(() => {
    if (listing.asset.json?.image) return
    setAssetImageUrl(DefaultNftBG.src)

    fetch(listing.asset.uri)
      .then(e => e.json())
      .then(({ image }) => setAssetImageUrl(image))
      .catch(e => {
        console.error(e)
        setAssetImageUrl(DefaultNftBG.src)
      })
  }, [listing.asset])

  return (
    <>
      <div className="w-full">
        <div className="flex items-center mt-[20px] gap-[10px]">
          <div className={styles.imageArea}>
            {assetImageUrl && <ImageWithFoster src={assetImageUrl} alt="" className="w-full h-full rounded-[4px]" />}
          </div>

          <div className="block">
            <div className={styles.offerName}>
              {offerType === 'made'
                ? 'You placed an offer of ' + getPriceValue(listing.price.basisPoints.toNumber()) + ' SOL for'
                : 'You received an offer of ' + getPriceValue(listing.price.basisPoints.toNumber()) + ' SOL for'}
            </div>
            <div className={styles.nftName} onClick={() => router.push(`/nft/${listing.asset.mintAddress.toBase58()}`)}>
              {listing.asset.name}
            </div>
            <div className={styles.date}>{getLocalDate(new Date(listing.createdAt.toNumber() * 1000))}</div>
          </div>
        </div>
        <div
          className="mt-[15px]"
        >
          <OutlineButton label={offerType === 'made' ? 'Cancel' : 'Accept'} fullWidth onClick={() => {
            if (offerType === 'made') onCancel(listing)
            else onAccept(listing)
          }}/>
        </div>
        <div className={styles.separator} />
      </div>
    </>
  )
}

const OfferAccordion = ({ data, onAccept, onCancel, offerType }: OfferAccordionProps) => {
  return (
    <div className="w-full flex flex-wrap gap-[10px]">
      {data.map((item, index) => (
        <div key={index} className="w-full relative">
          <OfferAccordionItem
            listing={item}
            onAccept={onAccept}
            onCancel={onCancel}
            offerType={offerType}
            index={index}
          />
        </div>
      ))}
    </div>
  )
}

export default OfferAccordion
